/**
 * Created by ok on 8/23/17.
 */
import React from 'react';
import {connect} from 'react-redux';
import {setActiveBreakpoint} from "../actions/setActiveBreakpoint";
import PropTypes from 'prop-types'
import breakpoints from './styles/breakpoints'

class MediaQueryWrapper extends React.Component {

    constructor( props ) {
        super( props );
        this.mediaQueryState = [];
    };

    // create the event handler inside componentDidMount
    componentDidMount() {

        // loop over our breakpoints object to create a media query
        // instance for each of our breakpoints
        Object.keys( breakpoints ).forEach( key => {
            // create a new media query object using the window.matchMedia api.
            // Read more here: https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia
            const query = window.matchMedia( `${breakpoints[key].query}` );

            // add the breakpoint value to the media query object
            query.data = breakpoints[key];

            // add the name
            query.name = key;

            // create the function that will run each
            // time the breakpoint is changed
            function breakpointChange() {
                // this function will communicate with our reducer
                this.dispatchActiveQuery();
            }

            // Attach the even listener to the query
            query.addListener( breakpointChange.bind( this ) );

            // push this query to our mediaQueryState array,
            // after the loops has run its course, we will
            // have an array that houses a mediaQuery object
            // for each breakpoint in our breakpoints object.
            this.mediaQueryState.push( query );
        } );

        // run the function once on componentDidMount to
        // record the initial breakpoint state of our viewport
        this.dispatchActiveQuery();
    }

    // create the function that will prepare our breakpoint object for dispatch
    dispatchActiveQuery() {
        const {dispatch} = this.props;

        // Assuming a desktop first responsive system, the active
        // breakpoint will always be the smallest one that satisfies
        // the media query. We use reduce to travel down the matched media queries
        // and return the smallest item that matches. In the event no breakpoints
        // match (such as when the viewport is larger than our largest breakpoint),
        // we return null
        const activeQuery = this.mediaQueryState.reduce( ( prev, curr ) => {
            return curr.matches ? curr : prev && prev.matches ? prev : null
        } );

        // In the event null was returned by activeQuery, we substitute 'default',
        // which will be the active breakpoint when no other breakpoint is matched
        const breakpointName = activeQuery ? activeQuery.name : 'default';

        // We will also record the numerical value for the matched breakpoint
        // as breakpointSize
        let breakpointData = activeQuery && activeQuery.data;
        breakpointData.windowHeight = window.outerHeight;
        breakpointData.windowWidth = window.outerWidth;


        // Now dispatch both values using the setActiveBreakpoint action
        dispatch( setActiveBreakpoint( breakpointName, breakpointData ) );
    }



    render() {
        return (
            <div>
                {this.props.children}
            </div>
        );
    };
}

MediaQueryWrapper.propTypes = {
    dispatch: PropTypes.func
};

export default connect()( MediaQueryWrapper );



// WEBPACK FOOTER //
// ./src/components/MediaQueryWrapper.js